import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardShell from "../../components/layout/DashboardShell";
import { Card, Pill, EmptyState } from "../../components/common/Primitives";
import api from "../../lib/api";

export default function StartupDealRooms() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/startup/deal-rooms").then((r) => setRows(r.data || [])); }, []);

  return (
    <DashboardShell title="Deal Rooms" subtitle="STARTUP · ACTIVE DEALS">
      {rows.length === 0 ? (
        <EmptyState title="No deal rooms yet" hint="Deal rooms are opened by VenturaZ advisors after serious investor interest." />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {rows.map((r) => (
            <Link to={`/deal-room/${r.deal_room_id}`} key={r.deal_room_id} className="border border-white/10 bg-white/70 backdrop-blur p-5 hover:border-gold/40 transition-colors">
              <div className="flex justify-between items-start">
                <div>
                  <div className="font-heading text-ink text-lg">Deal Room</div>
                  <div className="text-xs text-ink-muted font-mono mt-1">{r.deal_room_id}</div>
                </div>
                <Pill tone="gold">{r.stage}</Pill>
              </div>
              <div className="mt-4 text-sm text-ink-soft line-clamp-3">{r.deal_summary || "Structured deal workspace with documents, notes and timeline."}</div>
              <div className="mt-4 text-gold text-xs font-heading">Open →</div>
            </Link>
          ))}
        </div>
      )}
    </DashboardShell>
  );
}
